define('components/AboutUs',[
    "jquery",
    "logging"
], function ($, logging) {
    var _ModuleName = "About Us";

    function AboutUs(scope) {
        "use strict";

        // Collect some of the elements we'll need.
        var $blurb = $('.blurb p', scope);
        var $preview = $('.preview', $blurb);
        var $full = $('.full', $blurb);
        var $button = $('i.glyphicon-menu-down', scope);

        if ($preview.length && $full.length && $button.length) {
            // Configure the expansion button
            $button.click(function ( evt ) {
                evt.stopPropagation && evt.stopPropagation();
                evt.preventDefault && evt.preventDefault();

                // Toggle Visibility
                $preview.toggle();
                $full.toggle();

                // Toggle Arrow Direction
                if($button.hasClass('glyphicon-menu-down')) {
                    $button.removeClass('glyphicon-menu-down')
                            .addClass('glyphicon-menu-up');
                } else {
                    $button.removeClass('glyphicon-menu-up')
                            .addClass('glyphicon-menu-down');
                }
            });
        }

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new AboutUs(args.scope);
        }
    }
});
